import { render, staticRenderFns } from "./naturalace.vue?vue&type=template&id=a59a605a&scoped=true"
import script from "./naturalace.vue?vue&type=script&lang=js"
export * from "./naturalace.vue?vue&type=script&lang=js"
import style0 from "./naturalace.vue?vue&type=style&index=0&id=a59a605a&prod&scoped=true&lang=css"
import style1 from "./naturalace.vue?vue&type=style&index=1&id=a59a605a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59a605a",
  null
  
)

export default component.exports